import { createStyles, makeStyles } from '@material-ui/styles';
import IPhone from '../../../../assets/lots/challengeLotsBlock/iphone13.webp';
import AirPodsPro from '../../../../assets/lots/challengeLotsBlock/airpodspro.webp';
import AirPods from '../../../../assets/lots/challengeLotsBlock/airpods.webp';
import CarteCadeau from '../../../../assets/lots/challengeLotsBlock/cartecadeau.webp';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      backgroundColor: palette.common.primaryBlue,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '160%',
      backgroundPosition: 'bottom right -50px',
      height: '261px',
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.buttonShadow,
      color: palette.text.white,
      fontWeight: 500,
      textShadow: palette.shadows.textShadow,
      fontSize: '0.75rem',
      padding: '10px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '136.5px',
      userSelect: 'none'
    },
    title: {
      fontSize: '1.25rem',
      fontStyle: 'italic',
      margin: '0',
      width: '111.5px'
    },
    iphone: {
      backgroundImage: `url(${IPhone})`
    },
    airpodspro: {
      backgroundImage: `url(${AirPodsPro})`,
      backgroundPosition: 'bottom right -60px'
    },
    airpods: {
      backgroundImage: `url(${AirPods})`
    },
    cartecadeau: {
      backgroundImage: `url(${CarteCadeau})`
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
